import { useEffect, useState } from 'react';
import { PageHeader } from '../page-header';
import './Style.css';
import { apiV1 } from '../../lib/axios';
import moment from 'moment';
import { PendingTransactionModal } from './pendingTransactionModal';
import { IoMdEye } from 'react-icons/io';
import { toast } from 'react-toastify';

const PaginaAceitacoes = () => {
  const [transactions, setTransactions] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [filterStatus, setFilterStatus] = useState('PENDING');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const statusMap = {
    pending: 'Pendente',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
  }

  const transactionLabelMap = {
    'pix': 'PIX',
    'ted': 'Ted',
    'boleto': 'Pagamento de Boleto',
    'echeck': 'E-check',
  }

  const fetchPendingTransactions = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        ...(filterType && { type: filterType }),
        ...(filterStatus && { status: filterStatus }),
        page,
      });

      const response = await apiV1.get(`/transactions/pending?${queryParams.toString()}`);
      const { data, totalPages } = response.data;

      const transactions = data.map(transaction => ({
        ...transaction,
        value: transaction.payload.data?.value || transaction.payload.value,
        status: statusMap[transaction.status.toLowerCase()] || transaction.status,
        createdUser: transaction.createdByCompanyUser.name
      }));

      setTransactions(transactions);
      setTotalPages(totalPages);
      setSelectedTransactions([]);
    } catch (err) {
      console.error('Erro ao buscar transações:', err);
      toast.error('Erro ao buscar transações.');
    }
    setLoading(false);
  };

  const handleUpdateTransaction = async (transactionId, action) => {
    try {
      await apiV1.put(`/transactions/${transactionId}/${action}`);
      const message = action === 'approve' ? 'Transação aprovada com sucesso!' : 'Transação recusada com sucesso!';
      toast.success(message);
      fetchPendingTransactions();
    } catch (error) {
      console.error('Erro ao atualizar transação:', error);
      toast.error(error?.response?.data?.message || 'Erro ao atualizar transação. Tente novamente.');
    }
  }

  const handleBatchUpdate = async (action) => {
    try {
      await apiV1.put(`/transactions/batch-update`, {
        ids: selectedTransactions,
        action
      });
      const message = action === 'approve' ? 'Transações aprovadas com sucesso!' : 'Transações recusadas com sucesso!';
      toast.success(message);
      fetchPendingTransactions();
    } catch (error) {
      console.error('Erro ao atualizar em lote:', error);
      toast.error(error?.response?.data?.message || 'Erro ao atualizar transações. Tente novamente.');
    }
  };

  const toggleTransactionSelection = (transactionId) => {
    setSelectedTransactions((prev) =>
      prev.includes(transactionId) ? prev.filter(id => id !== transactionId) : [...prev, transactionId]
    );
  };

  useEffect(() => {
    fetchPendingTransactions();
  }, [filterType, filterStatus, page]);

  const handleShowModal = (transaction) => {
    setSelectedTransaction(transaction);
    setShowModal(true);
  }

  const renderPagination = () => (
    <div className="pagination">
      <button disabled={page === 1} onClick={() => setPage(page - 1)}>Anterior</button>
      <span>Página {page} de {totalPages || 1}</span>
      <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Próxima</button>
    </div>
  );

  return (
    <div className="pagina-aceitacoes">
      <div className="header">
        <PageHeader title="Aprovações de Transações" pages={[{ name: 'Aprovações de Transações', link: "" }]} />
      </div>

      <div className="transaction-approvals-wrapper">
        <h2 className="page-title">Transações de Sub Acessos</h2>

        <div className="filters">
          <select className="filter-input" value={filterType} onChange={(e) => { setPage(1); setFilterType(e.target.value); }}>
            <option value="">Todos os tipos</option>
            <option value="PIX">{transactionLabelMap['pix']}</option>
            <option value="TED">{transactionLabelMap['ted']}</option>
            <option value="BOLETO">{transactionLabelMap['boleto']}</option>
            <option value="ECHECK">{transactionLabelMap['echeck']}</option>
          </select>

          <select className="filter-input" value={filterStatus} onChange={(e) => { setPage(1); setFilterStatus(e.target.value); }}>
            <option value="">Todos os status</option>
            <option value="PENDING">Pendente</option>
            <option value="APPROVED">Aprovado</option>
            <option value="REJECTED">Rejeitado</option>
          </select>
        </div>

        {selectedTransactions.length > 0 && (
          <div className="bulk-actions mb-3 d-flex">
            <button className="btn-approve" onClick={() => handleBatchUpdate('approve')}>Aprovar Selecionadas</button>
            <button className="btn-reject" onClick={() => handleBatchUpdate('reject')}>Rejeitar Selecionadas</button>
          </div>
        )}

        <div className="transactions-table-wrapper">
          {loading ? (
            <p>Carregando...</p>
          ) : (
            <table className="transactions-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Data</th>
                  <th>Tipo</th>
                  <th>Realizada por</th>
                  <th>Valor</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {
                  transactions.map((transaction, index) => (
                    <tr key={index}>
                      <td>
                        {transaction.status.toLowerCase() === 'pendente' && (
                          <input
                            type="checkbox"
                            checked={selectedTransactions.includes(transaction.id)}
                            onChange={() => toggleTransactionSelection(transaction.id)}
                          />
                        )}
                      </td>
                      <td>{moment(transaction.createdAt).format('DD/MM/YYYY')}</td>
                      <td>{transactionLabelMap[transaction.type.toLowerCase()]}</td>
                      <td>{transaction.createdUser}</td>
                      <td>{Number(transaction.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                      <td><span className={`status ${transaction.status.toLowerCase()}`}>{transaction.status}</span></td>
                      <td>
                        <button type="button" class="btn btn-outline-secondary btn-sm" onClick={() => handleShowModal(transaction)}>
                          <IoMdEye /> Detalhes
                        </button>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          )}
        </div>

        {renderPagination()}
      </div>
      <PendingTransactionModal isOpen={showModal} transaction={selectedTransaction} onClose={() => setShowModal(false)} fetchPendingTransactions={fetchPendingTransactions} />
    </div>
  );
};

export default PaginaAceitacoes;
